import { HeroContainer } from "../atoms/containers/ContentContainers";
import { HeroContent } from "../molecules/hero_content/HeroContent";

export function Hero() {
	return (
		<HeroContainer id="hero">
			<HeroContent />
		</HeroContainer>
	);
}
